var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,18 L18,18 L18,12.9975446 C18,12.446616 18.4426603,12 18.9989566,12 L20.0010434,12 C20.5527519,12 21,12.4463114 21,12.9975446 L21,20.0024554 C21,20.2778851 20.8893628,20.5272431 20.7092008,20.7077578 C20.53058,20.8883787 20.2810806,21 20.0012539,21 L0.998746091,21 C0.723183303,21 0.47368595,20.8895221 0.292984829,20.70959 C0.111783661,20.5273949 0,20.278037 0,20.0024554 L0,12.9975446 C0,12.446616 0.442660332,12 0.998956561,12 L2.00104344,12 C2.55275191,12 3,12.4463114 3,12.9975446 L3,18 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 6,
  width: 3,
  height: 8,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(9.085786, 5.914214) rotate(-45.000000) translate(-9.085786, -5.914214) ",
  x: 5.58578644,
  y: 4.41421356,
  width: 7,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(11.914214, 5.914214) rotate(-315.000000) translate(-11.914214, -5.914214) ",
  x: 8.41421356,
  y: 4.41421356,
  width: 7,
  height: 3,
  rx: 1
})))));
export default SvgUpload;